import { render, staticRenderFns } from "./proformaToFatura.vue?vue&type=template&id=6420432c&scoped=true&"
import script from "./proformaToFatura.vue?vue&type=script&lang=js&"
export * from "./proformaToFatura.vue?vue&type=script&lang=js&"
import style0 from "./proformaToFatura.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./proformaToFatura.vue?vue&type=style&index=1&id=6420432c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6420432c",
  null
  
)

export default component.exports